import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-079d5380"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "fas fa-camera-retro me-2" }),
    /*#__PURE__*/_createTextVNode("ผลการปฏิบัติราชการในพื้นที")
  ]),
  /*#__PURE__*/_createElementVNode("h6", { class: "card-subtitle text-muted" }, "รายงานผลการปฏิบัติราชการในพื้นที")
], -1))
const _hoisted_3 = { class: "card-body my-3" }
const _hoisted_4 = {
  key: 1,
  class: "table-responsive"
}
const _hoisted_5 = {
  ref: "datatable",
  class: "table table-hover"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "#"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "ชื่อกิจกรรม"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "วันที่"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "สถานที่ตรวจราชการ")
  ])
], -1))
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "far fa-calendar me-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingComponent = _resolveComponent("LoadingComponent")!
  const _directive_dompurify_html = _resolveDirective("dompurify-html")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_LoadingComponent, { key: 0 }))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("table", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activities, (activity, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: index,
                    class: "row-hover",
                    onClick: ($event: any) => (_ctx.activityClick(activity.id))
                  }, [
                    _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                    _createElementVNode("td", null, [
                      _hoisted_8,
                      _createTextVNode(_toDisplayString(activity.name), 1)
                    ]),
                    _createElementVNode("td", null, _toDisplayString(_ctx.thaiDate(activity.startDate)) + " - " + _toDisplayString(_ctx.thaiDate(activity.endDate)), 1),
                    _withDirectives(_createElementVNode("td", null, null, 512), [
                      [_directive_dompurify_html, _ctx.provincesHtml(activity.provinces)]
                    ])
                  ], 8, _hoisted_7))
                }), 128))
              ])
            ], 512)
          ]))
    ])
  ]))
}